import type { BisacCode } from "reedy-data/api";

const HEADING_SEPARATOR = " / ";

export const formatBisacHeading = ({
  headingPath,
}: Pick<BisacCode, "headingPath">) => headingPath.join(HEADING_SEPARATOR);
